import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid } from '@web/utils';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import { Icon, SpinnerFilledComponent } from '@web/shared/ui';
import { AdminBrandDataSourceService } from '../../services/admin-brand-data-source.service';
import { BrandDetailsComponent } from '../../../shared/components/brand-details/brand-details.component';
import { AdminBrandDetails } from '../../models/admin-brand-details';
import { AdminBrandBannerPreviewComponent } from '../admin-brand-banner-preview/admin-brand-banner-preview.component';

@Component({
  selector: 'app-admin-brand-details',
  imports: [
    AdminBrandBannerPreviewComponent,
    CommonModule,
    BrandDetailsComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './admin-brand-details.component.html',
  styleUrl: './admin-brand-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandDetailsComponent {
  private readonly brandDataSource = inject(AdminBrandDataSourceService);

  public readonly id = input.required<Guid>();
  public readonly editClickEvent = output<void>();

  protected readonly id$ = toObservable(this.id);
  protected readonly details$ = this.detailsSource();
  protected readonly Icon = Icon;

  public handleEditClickEvent(): void {
    this.editClickEvent.emit();
  }

  private detailsSource(): Observable<AdminBrandDetails> {
    return this.id$.pipe(
      switchMap((id) => this.brandDataSource.fetchDetailsById(id)),
    );
  }
}
